// GENERATED by scripts/gen-route-manifest.mjs -- do not edit by hand.
  // Regenerate after adding or removing a <Route> in src/App.tsx:
  //   node scripts/gen-route-manifest.mjs
  // routeManifest.drift.test.ts fails the build if this drifts from App.tsx.

  export const ROUTE_PATTERNS = [
    "*",
  "/",
  "/account",
  "/achievements",
  "/admin",
  "/admin/ai-models",
  "/admin/audit-logs",
  "/admin/blog",
  "/admin/bug-reports",
  "/admin/bulk-playlists",
  "/admin/campaigns",
  "/admin/client-errors",
  "/admin/coin-monitor",
  "/admin/curator-accounts",
  "/admin/featured",
  "/admin/generation-monitor",
  "/admin/homepage-carousel",
  "/admin/insights",
  "/admin/invitations",
  "/admin/invoices",
  "/admin/payments-monitor",
  "/admin/perf",
  "/admin/referrals",
  "/admin/scripts",
  "/admin/sentry",
  "/admin/settings",
  "/admin/strategy",
  "/admin/tracking",
  "/admin/users",
  "/admin/winback",
  "/admin/youtube-conversions",
  "/ai-playlist-generator",
  "/analytics",
  "/auth",
  "/blog",
  "/blog/:slug",
  "/buy-coins",
  "/claim-gift",
  "/coins-history",
  "/coins-success",
  "/community",
  "/contact",
  "/convert",
  "/convert/youtube-to-spotify",
  "/converter",
  "/create/:slug",
  "/embed/:id",
  "/exports",
  "/for-venues",
  "/free-ai-playlist-no-premium",
  "/generate",
  "/gift-coins",
  "/how-it-works",
  "/invite/:token",
  "/my-vibe",
  "/onboarding-preview",
  "/payments",
  "/playlist-generator",
  "/playlist-maker",
  "/playlists",
  "/playlists/:id",
  "/pricing",
  "/privacy",
  "/profile",
  "/purchase-history",
  "/roast",
  "/settings",
  "/share/:slug",
  "/spotify-playlist-creator",
  "/spotify-to-youtube",
  "/terms",
  "/youtube-music-playlist-generator",
  "/youtube-to-spotify",
  ] as const;
  